import React from 'react';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Grid, Typography } from '@mui/material';

export default function BookedOut() {
  return (
    <>
      <Grid container direction="row" justifyContent="center" sx={{ mb: 2 }}>
        <SentimentDissatisfiedIcon color="warning" sx={{ fontSize: 80 }} />
      </Grid>
      <Typography sx={{ textAlign: 'center', mb: 2 }} variant="h4">
        Diese Veranstaltung ist bereits ausgebucht.
      </Typography>
      <Typography sx={{ textAlign: 'center' }}>
        Eine neue Registrierung ist derzeit nicht mehr möglich.
      </Typography>
    </>
  );
}
